import React from "react";
import "./relatedSearches.css";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { RELATED_SEARCHES } from "../../data/relatedSearches";

const RelatedSearches = () => {
  const navigate = useNavigate();

  const handleClick = (navigateTo: string) => {
    if (navigateTo.startsWith("http")) {
      window.open(navigateTo, "_blank", "noopener,noreferrer");
    } else {
      navigate(navigateTo);
    }
  };

  return (
    <div className="related-searches">
      <h3 className="rs-title">Related searches</h3>
      <div className="rs-grid">
        {RELATED_SEARCHES.map((rs) => (
          <button
            key={rs.query}
            className="rs-pill"
            onClick={() => handleClick(rs.navigateTo)}
          >
            <FontAwesomeIcon icon={faSearch} className="rs-icon" />
            <span>{rs.query}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default RelatedSearches;
